//export const baseUrl = "http://192.168.1.188:9899";
export const baseUrl = "https://m1blog.aaragroups.com";

// export const baseUrl =
//   process.env.NODE_ENV === "production"
//     ? "https://m1blog.aaragroups.com"
//     : "http://192.168.1.188:9898";
export const imageFormat = (url) => {
  return `${baseUrl}${url}`;
};
export const WebsocketBaseUrl = "wss://comblog.aarasocial.com/";
